export const GET_USERSETTINGS_REQUEST = 'GET_USERSETTINGS_REQUEST';
export const GET_USERSETTINGS_SUCCESS = 'GET_USERSETTINGS_SUCCESS';
export const GET_USERSETTINGS_FAIL = 'GET_USERSETTINGS_FAIL';
export const UPDATE_USERSETTINGS_REQUEST = 'UPDATE_USERSETTINGS_REQUEST';
export const UPDATE_USERSETTINGS_SUCCESS = 'UPDATE_USERSETTINGS_SUCCESS';
export const UPDATE_USERSETTINGS_FAIL = 'UPDATE_USERSETTINGS_FAIL';

export const UPDATE_EMAILALERT_REQUEST = 'UPDATE_EMAIL_ALERT_REQUEST';
export const UPDATE_EMAILALERT_SUCCESS = 'UPDATE_EMAIL_ALERT_SUCCESS';
export const UPDATE_EMAILALERT_FAIL = 'UPDATE_EMAIL_ALERT_FAIL';

